<template>
    <v-row class="mr-2 ml-2 mt-2" no-gutters>
        <v-col cols="12" md class="d-flex justify-start mb-1">
            <h2 class="titulos">{{ titulo }}</h2>
        </v-col>

        <v-col cols="12" md="6" class="d-flex justify-end mb-1">
            <div class="cont-botones">
                <router-link
                    v-for="(btn, index) in botones"
                    :key="index"
                    :to="generarRuta(btn)">
                    <button color="#4CABD3" class="button boton-principal">
                        <v-icon>{{ btn.icon }}</v-icon>
                        {{ btn.label }}
                    </button>
                </router-link>
            </div>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: 'HeaderAcciones',
    props: {
        titulo: {
            type: String,
            required: true,
        },
        botones: {
            type: Array,
            required: true,
            validator: (value) => {
                return value.every(
                    (btn) => 'name' in btn && 'label' in btn && 'icon' in btn,
                );
            },
        },
        idParametro: {
            type: [String, Number],
            default: null,
        },
    },
    methods: {
        generarRuta(btn) {
            return {
                name: btn.name,
                params:
                    this.idParametro !== null ? { id: this.idParametro } : {},
            };
        },
    },
};
</script>

<style scoped>
.cont-botones {
    gap: 5px;
    display: flex;
    align-items: center;
}
</style>
